var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ZebraBreadcrumbCaiot',{attrs:{"menuHeader":_vm.menuHeader,"menuAside":_vm.menuAside}})
}
var staticRenderFns = []

export { render, staticRenderFns }